import { hWebCrossUpperLeft, hWebCrossUpperLeft2, hWebCrossUpperRight } from '../lace/hWebCross'
import { middleSidePartOfWeb, topSidePartOfWebWithJoint, topSidePartOfWebWithJointStraightLace } from './parts/sideParts'

export const wi7Web = (ctx: CanvasRenderingContext2D, webColor: string, laceColor: string, stitchColor: string, edgeColor: string): void => {
  ctx.lineWidth = 1.0
  ctx.strokeStyle = '#282828'
  // 捕球面とウェブ横2を繋ぐ革紐
  hWebCrossUpperLeft(ctx, laceColor, 0, 0) // クロス部分の右
  hWebCrossUpperLeft(ctx, laceColor, -3, 3) // クロス部分の右
  hWebCrossUpperRight(ctx, laceColor, 0, 0) // クロス部分の右
  hWebCrossUpperRight(ctx, laceColor, -3, 3) // クロス部分の右
  hWebCrossUpperLeft2(ctx, laceColor, 0, 0) // クロス部分の左
  hWebCrossUpperLeft2(ctx, laceColor, -3, 3) // クロス部分の左
  // ウェブ縦
  ctx.fillStyle = webColor
  ctx.beginPath()
  ctx.moveTo(266, 260) // 左＿上
  ctx.quadraticCurveTo(273, 275, 273, 275) // 左＿下
  ctx.quadraticCurveTo(319, 218, 319, 218) // 右＿下
  ctx.quadraticCurveTo(314, 190, 314, 190) // 右＿上
  ctx.quadraticCurveTo(284, 219, 266, 260) // 左＿上
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  // ヘリ革＿左
  ctx.fillStyle = edgeColor
  ctx.beginPath()
  ctx.moveTo(258, 241) // 左＿上
  ctx.quadraticCurveTo(272, 275, 272, 275) // 左＿下
  ctx.quadraticCurveTo(280, 264, 280, 264) // 右＿下
  ctx.quadraticCurveTo(265, 228, 265, 228) // 右＿上
  ctx.quadraticCurveTo(258, 241, 258, 241) // 左＿上
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  // ヘリ革＿右
  ctx.beginPath()
  ctx.moveTo(305, 186) // 左＿上
  ctx.quadraticCurveTo(316, 228, 316, 228) // 左＿下
  ctx.quadraticCurveTo(323, 218, 323, 218) // 右＿下
  ctx.quadraticCurveTo(313, 178, 313, 178) // 右＿上
  ctx.quadraticCurveTo(305, 186, 305, 186) // 左＿上
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  // stitchここから
  ctx.lineWidth = 1.2
  ctx.strokeStyle = stitchColor
  ctx.beginPath()
  ctx.setLineDash([3, 3])
  // Hウェブ縦＿左＿内側
  ctx.moveTo(277, 250) // 上
  ctx.quadraticCurveTo(285, 270, 285, 270) // 下
  // Hウェブ縦＿右＿内側
  ctx.moveTo(308, 198) // 上
  ctx.quadraticCurveTo(313, 220, 313, 222) // 下
  ctx.stroke()
  ctx.setLineDash([])
  ctx.closePath()

  // ウェブ横1(先端)
  topSidePartOfWebWithJointStraightLace(ctx, webColor, laceColor, stitchColor)
  // ウェブ横2
  middleSidePartOfWeb(ctx, webColor, stitchColor, 15, 35)
}
